import styled from "styled-components";
import { StarIcon } from "@ui/components/icons";

export const Star = styled(StarIcon)<{ $isFilled?: boolean }>`
	path {
		${({ theme, $isFilled }) => !$isFilled && `fill: ${theme.colors.lightergray}`}
	}
`;
